import { render } from "./wallItem.vue?vue&type=template&id=52939940&scoped=true"
import script from "./wallItem.vue?vue&type=script&lang=js"
export * from "./wallItem.vue?vue&type=script&lang=js"

import "./wallItem.vue?vue&type=style&index=0&id=52939940&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52939940"]])

export default __exports__